export const summaryQueryKey = (kind, type, companyId, facilityId, period, endingMonth) =>
  JSON.stringify([kind, type, String(companyId || ""), String(facilityId || ""), String(period), String(endingMonth)]);

// useRequest retains previous data while refreshing or after a failed request.
// Only expose the result of this exact successful request.
export const bindSummarySnapshot = (request, queryKey) => {
  const matches = request.data?.queryKey === queryKey;
  const status = request.loading ? "loading" : request.error ? "error" : !matches ? "loading" : "ready";
  return {
    data: status === "ready" ? request.data.data : undefined,
    status,
    loading: status === "loading",
    error: request.error,
    capturedAt: status === "ready" ? request.data.capturedAt : null,
    refresh: request.refreshAsync,
  };
};

export const combineAiDataSources = (...sources) => ({
  status: sources.some((source) => source.status === "error") ? "error"
    : sources.every((source) => source.status === "ready") ? "ready" : "loading",
  capturedAt: sources.every((source) => source.capturedAt)
    ? new Date(Math.min(...sources.map((source) => Date.parse(source.capturedAt)))).toISOString()
    : null,
  refresh: () => Promise.allSettled(sources.map((source) => source.refresh())),
});
